<template>
<div ref="subGlobal" class="global-main global-shadow">
  <div class='global-panel' v-loading.body="loading.main" style="font-size: 20px;text-align: center;line-height: 40px;padding-top: 20px;padding-bottom: 80px">
    <div style="margin-bottom: 20px;">
      欢迎使用教务系统
    </div>
    <img src="static/img/main.png" style="width: 200px;height: 200px;margin-bottom: 20px;"/>
    <div style="margin-bottom: 20px;">
      <el-button type="primary"  @click="goCourse()">点 此 选 课</el-button>
      </br></br>
      <el-button type="success"  @click="goScore()">成 绩 查 询</el-button>
      </br></br>
      <el-button type="warning"  @click="goAllocation()">分 班 查 询</el-button>
      </br></br>
      <el-button type="danger"  @click="goHistoryScore()">历 史 成 绩</el-button>
    </div>

  </div>
</div>
</template>

<script>
export default {
  name: 'SystemHome',
  data () {
    return {
      // 遮罩
      loading: {main: false},
      // 可见
      visible: {}
    }
  },
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';
  },
  methods: {
    goCourse: function () {
      var vm = this;
      // 作为正常页面打开
      vm.$router.push({path: '/CourseChoose'});
    },
    goScore: function () {
      var vm = this;
      // 作为正常页面打开
      vm.$router.push({path: '/ScoreQuery/score'});
    },
    goAllocation: function () {
      var vm = this;
      // 作为正常页面打开
      vm.$router.push({path: '/ScoreQuery/allocation'});
    },
    goHistoryScore: function () {
      var vm = this;
      // 作为正常页面打开
      vm.$router.push({path: '/ScoreExport'});
    },
  }
}
</script>

<style>
  .global-main {
    padding: 5px 0;
    position: relative;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/app/SystemHome.vue